import { Route, Routes } from 'react-router-dom';
import { ProfilePage } from './Profile';

export const SetupRoutes = () => {
  return (
    <Routes>
      <Route path="profile" element={<ProfilePage />} />
    </Routes>
  );
};
